import fetch from 'auth/FetchInterceptor'

const gestaoAcessoService = {}

gestaoAcessoService.listar = function ({ page = 0, size = 10, contratoId = '', perfil = '', nome = '', email = '' } = {}) {
  const params = { page, size }
  if (contratoId) params.contratoId = contratoId
  if (perfil) params.perfil = perfil
  if (nome) params.nome = nome
  if (email) params.email = email
  return fetch({
    url: '/gestao-acesso/login',
    method: 'get',
    params,
  })
}

gestaoAcessoService.criar = function (data) {
  return fetch({
    url: '/gestao-acesso/login',
    method: 'post',
    data: data,
  })
}

gestaoAcessoService.editar = function (id, data) {
  return fetch({
    url: `/gestao-acesso/login/${id}`,
    method: 'put',
    data: data,
  })
}

gestaoAcessoService.titulares = function () {
  return fetch({
    url: '/gestao-acesso/titulares',
    method: 'get',
  })
}

gestaoAcessoService.inativar = function (id, contratoId) {
  return fetch({
    url: `/gestao-acesso/login/${id}/inativar`,
    method: 'put',
    params: contratoId ? { contratoId } : {},
  })
}

gestaoAcessoService.veiculosDoLogin = function (id) {
  return fetch({
    url: `/gestao-acesso/login/${id}/veiculos`,
    method: 'get',
  })
}

gestaoAcessoService.vincular = function (id, rastreadoresIds) {
  return fetch({
    url: `/gestao-acesso/login/${id}/veiculos`,
    method: 'post',
    data: { rastreadoresIds },
  })
}

gestaoAcessoService.desvincular = function (id, rastreadoresIds) {
  return fetch({
    url: `/gestao-acesso/login/${id}/veiculos`,
    method: 'delete',
    data: { rastreadoresIds },
  })
}

gestaoAcessoService.criarGestor = function (data) {
  return fetch({
    url: '/gestao-acesso/gestor-frotas',
    method: 'post',
    data: data,
  })
}

gestaoAcessoService.concederContratos = function (id, contratosIds) {
  return fetch({
    url: `/gestao-acesso/gestor-frotas/${id}/contratos`,
    method: 'post',
    data: { contratosIds },
  })
}

export default gestaoAcessoService
